import * as types from './mutation-types';
import http from '~/http';

export const setCompanies = (context, payload) => {
  context.commit(types.SET_QUERY, payload);
  context.dispatch('setLoading', true);
  http
    .get('companies', { params: context.state.query })
    .then(({ data }) => {
      context.commit(types.SET_COMPANIES, data.data);
    })
    .finally(() => {
      context.dispatch('setLoading', false);
    });
};

export const setQuery = (context, payload) => {
  context.commit(types.SET_QUERY, payload);
  context.dispatch('setCompanies');
};

export const resetQuery = context => {
  context.commit(types.RESET_QUERY);
  context.dispatch('setCompanies');
};

export const setLoading = (context, payload) => {
  context.commit(types.SET_LOADING, payload);
};
